import { api } from "./api/client";

export interface SyncResult {
  activas: number;
  nuevas: number;
  actualizadas: number;
  desaparecidas: number;
  cambiosDetectados: number;
  detallesConsultados: number;
  enriquecidas: number;
  /** Filas cerradas por el barrido de reconciliación (sin consumir cuota MP). */
  reconciliadas: number;
  /** Releases OCDS consultados (API abierta, sin cuota). */
  ocdsConsultadas?: number;
  ocdsCruzadas?: number;
  ocdsNuevas?: number;
  /** Fase 2: licitaciones corregidas o creadas por el barrido por estado. */
  licitacionesPorEstado?: number;
  /** Fase 2: órdenes de compra ingestadas o actualizadas. */
  ordenesCompra?: number;
  /** Fase A: OC recuperadas por el backfill histórico. */
  ocBackfill?: number;
  /** Fase A: vínculos licitación↔OC sugeridos automáticamente. */
  ocVinculosSugeridos?: number;
  /** Fase 2: fichas de proveedor refrescadas desde el directorio oficial. */
  proveedoresRefrescados?: number;
  /** Fase 2: fichas de organismo comprador refrescadas. */
  organismosRefrescados?: number;

  requests: number;
  errores: number;
  duracionMs: number;
  estado: "ok" | "parcial" | "error";
  mensaje?: string;
}

export interface RepararDiaResult {
  consultadas: number;
  nuevas: number;
  actualizadas: number;
  errores: number;
}

export const syncService = {
  /** Dispara la sincronización completa con Mercado Público (interino, sin scheduler externo aún). */
  runManual: async () => (await api.post<SyncResult>("/sync/manual")).data,

  /** Herramienta interna: recupera las licitaciones de un día (ddmmaaaa). */
  repararDia: async (fecha: string) =>
    (await api.post<RepararDiaResult>("/sync/reparar-dia", { fecha })).data,
};
